import React from 'react';
import { FlowMetadataContext, IFlowMetadataContext } from '../../Components/Contexts/FlowMetadataContext';

export default function useFlowMetadata(): IFlowMetadataContext {
	const context = React.useContext(FlowMetadataContext);
	if (!context) {
		throw new Error('useFlowMetadata must be used within a FlowMetadataProvider');
	}
	return context;
}
